import React, {useState, useRef} from 'react';
import FormField from '../FormField/FormField';
import SubmitButton from '../SubmitButton/SubmitButton';
import './InviteEmployee.css';
import {useMemo} from 'react';

const InviteEmployee = ({
  isLoading,
  onSubmit,
  errorText,
  isActive,
  onClose,
}) => {
  const [login, setLogin] = useState('');

  const buttonRef = useRef(null);

  const fieldConfigurations = useMemo(
    () => [{key: 'name', label: 'Пригласить сотрудника', type: 'text'}],
    []
  );

  const handleChange = (e) => {
    setLogin(e.target.value);
  };

  const handleSubmit = () => {
    onSubmit(login);
  };

  const handleClosePopup = () => {
    setLogin('');
    onClose();
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(login);
    }
  };
  return (
    <>
      <div
        onClick={handleClosePopup}
        className={`overlay ${isActive ? 'show' : 'hide'}`}
      ></div>
      <div className={`invite-employee ${isActive ? 'show' : 'hide'}`}>
        {fieldConfigurations.map((f) => (
          <FormField
            key={f.key}
            label={f.label}
            type={f.type}
            name={f.key}
            value={login}
            onChange={handleChange}
            error={errorText}
            placeholder={f.placeholder}
            required={true}
            modifierClassesFormField={{field: 'invite-employee__wrapper-field'}}
            onKeyDown={onKeyDown}
          />
        ))}
        <SubmitButton
          ref={buttonRef}
          text='Пригласить'
          disabled={!login}
          onClick={handleSubmit}
          type='button'
          className='invite-employee__button'
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default InviteEmployee;
